export default "__VITE_ASSET__BWeDCZtN__"